// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-restricted-imports, babel/camelcase, multiline-comment-style */
// FIXME: remove this disable directive and fix the ESLint error(s)

// @ts-expect-error: Flow to TS migration.
import _ from "lodash"
import { fromJS } from "immutable"
// FIXME: remove this disable directive and fix the ESLint error(s)

import Payment from "@kiwicom/frontend-app/scripts/containers/mutable/Payment"
import Price from "@kiwicom/frontend-common/records/Price"
import AdditionalService from "@kiwicom/frontend-common/records/AdditionalService"
import { mapToUtcMoment } from "@kiwicom/frontend-common/services/momentHelpers/momentHelpers"
import cuckoo from "@kiwicom/frontend-common/services/cuckoo/cuckoo"
import { cuckooEvents } from "@kiwicom/frontend-common/consts/enums"
import { addHours } from "date-fns"
import legacyParse from "@radek-palisa/date-fns-upgrade/lib/v2/legacyParse"

import {
  API_CATEGORIES_TO_SERVICES,
  DEFAULT_EXTRAS_EXPIRATION_TIME,
  SERVICES,
} from "../../../../../../../consts/additionalServices"
import { API_CATEGORIES } from "../../../../../../../consts/booking"
import type {
  AdditionalBookingInput,
  OrderItemInput,
} from "../../../../../../../records/bookingInput"

import { OrderItem } from "../../../scenes/BookingPayment/services/constants/types"

type MapOrderItems = {
  item_categories?: OrderItemInput[]
  category: string
  price: number
  currency: string
}

export const mapperOrderItems = ({
  item_categories,
  category,
  price,
  currency,
}: MapOrderItems): OrderItem[] => {
  if (item_categories) {
    const mappedOrderItems = item_categories.map<OrderItem>((item) => {
      // @ts-expect-error: Flow to TS migration.
      if (!API_CATEGORIES_TO_SERVICES[item.category])
        cuckoo.error(cuckooEvents.MMB_MAPPER_SERVICES_UNKNOWN_CATEGORY, {
          category: item.category,
        })

      return {
        // @ts-expect-error: Flow to TS migration.
        category: API_CATEGORIES_TO_SERVICES[item.category] || SERVICES.EXTRA,
        price: Price.fromServer(item.price),
      }
    })
    // change order (first service, then fee)
    const serviceItem = mappedOrderItems.filter((item) => item.category !== SERVICES.PROCESSING_FEE)
    const feeItem = mappedOrderItems.filter((item) => item.category === SERVICES.PROCESSING_FEE)
    return [...serviceItem, ...feeItem]
  }
  return [
    {
      category,
      price: new Price({ currency, amount: Number(price) }),
    },
  ]
}

export default function mapperManageBookingChange(input: AdditionalBookingInput) {
  const price = input.payment_gate === "credits" ? input.price : input.payment_price
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  const currency = input.payment_currency && input.payment_currency.toLowerCase()
  const { category: backendCategory, booked } = input
  const created = mapToUtcMoment(booked)
  const params = {
    id: input.abid,
    backendCategory,
    created,
    expiresAt: input.expires_at
      ? mapToUtcMoment(input.expires_at)
      : addHours(legacyParse(created), DEFAULT_EXTRAS_EXPIRATION_TIME),
    status: input.final_status,
    payment: new Payment({
      gate: input.payment_gate,
      currency,
      credits: input.credits_payment_amount,
      // TODO: that's not right, credits can be used together with normal payment... payment = payment_price + credits_payment_amount
      amount: price,
    }),
    orderItems: mapperOrderItems({
      ...input,
      /* $FlowFixMe This comment suppresses an error found when upgrading Flow
       * to v0.118.0. To view the error, delete this comment and run Flow. */
      // @ts-expect-error: Flow to TS migration.
      price,
      currency,
    }),
    offerId: input.offer_id,
    itineraryChangeType: input.itinerary_change_type,
  } as const

  // @ts-expect-error: Flow to TS migration.
  if (!API_CATEGORIES_TO_SERVICES[input.category])
    cuckoo.error(cuckooEvents.MMB_MAPPER_SERVICES_UNKNOWN_CATEGORY, {
      category: input.category,
    })

  if (input.category === API_CATEGORIES.UPDATE_INSURANCES) {
    return new AdditionalService({
      ...params,
      category: SERVICES.INSURANCE,
      params: input.data.data, // superugly, force backend to change this
    })
  }

  if (input.category === API_CATEGORIES.COVER_MORE) {
    return new AdditionalService({
      ...params,
      category: SERVICES.COVER_MORE,
    })
  }

  if (input.category === API_CATEGORIES.AXA_US) {
    return new AdditionalService({
      ...params,
      category: SERVICES.AXA_US,
    })
  }

  if (input.category === API_CATEGORIES.DISRUPTION_PROTECTION) {
    return new AdditionalService({
      ...params,
      category: SERVICES.DISRUPTION_PROTECTION,
    })
  }

  // This is for SCHEDULED CHANGE and FLIGHT CHANGE
  if (
    input.category === API_CATEGORIES.FLIGHTS ||
    input.category === API_CATEGORIES.CARRIER_ITINERARY_CHANGE
  ) {
    return new AdditionalService({
      ...params,
      category: SERVICES.CHANGE_FLIGHTS,
    })
  }

  if (input.category === API_CATEGORIES.PASSENGER_EDIT) {
    return new AdditionalService({
      ...params,
      category: SERVICES.PASSENGER_EDIT,
    })
  }
  if (input.category === API_CATEGORIES.SERVICE_MEALS_ON_BOARD) {
    return new AdditionalService({
      ...params,
      category: SERVICES.MEALS,
      params: fromJS(input.data),
    })
  }
  if (input.category === API_CATEGORIES.PRICE_CHANGE) {
    return new AdditionalService({
      ...params,
      category: SERVICES.PRICE_CHANGE,
      description: input.comment,
    })
  }
  if (input.category && _.startsWith(input.category, "service")) {
    // pending additional service
    return new AdditionalService({
      ...params,
      description: input.comment,
      category: input.category.replace("service.", ""),
    })
  }
  if (input.category === "seating" && input.data) {
    return new AdditionalService({
      ...params,
      category: SERVICES.SEATING,
      params: fromJS({ requestedSeats: input.data }),
    })
  }

  // NEST MAMBO
  if (input.category === API_CATEGORIES.NEST_PASSENGER_CHANGE) {
    return new AdditionalService({
      ...params,
      category: SERVICES.NEST_PASSENGER_CHANGE,
      description: input.comment,
    })
  }
  if (input.category === API_CATEGORIES.NEST_BOOKING_RESTORE) {
    return new AdditionalService({
      ...params,
      category: SERVICES.NEST_BOOKING_RESTORE,
      description: input.comment,
    })
  }
  if (input.category === API_CATEGORIES.NEST_OTHER) {
    return new AdditionalService({
      ...params,
      category: SERVICES.NEST_OTHER,
      description: input.comment,
    })
  }
  if (input.category === API_CATEGORIES.NEST_CHANGE_FLIGHTS) {
    return new AdditionalService({
      ...params,
      category: SERVICES.NEST_CHANGE_FLIGHTS,
      description: input.comment,
    })
  }

  if (input.category === API_CATEGORIES.ASSISTED_REFUND) {
    return new AdditionalService({
      ...params,
      category: SERVICES.ASSISTED_REFUND,
    })
  }

  if (
    input.category === API_CATEGORIES.EXTRAS_BAGS ||
    input.category === API_CATEGORIES.SERVICE_BAGGAGE ||
    input.bags
  ) {
    return new AdditionalService({
      ...params,
      category: SERVICES.BAGGAGE,
      description: input.comment,
      params: {
        bags: input.bags, // backend sends 0
      },
    })
  }

  if (input.comment) {
    // When there is bags == 0 and there is some comment => it means that this change was created manually by some booker
    return new AdditionalService({
      ...params,
      category: SERVICES.EXTRA,
      description: input.comment,
    })
  }

  return new AdditionalService({
    category: SERVICES.EXTRA,
    ...params,
  })
}
